import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';
import Logout from './views/Logout.vue';
import About from './views/About.vue';
import { authGuard } from './auth/authGuard';

Vue.use(Router);

function load(component) {
    // '@' is aliased to src/components
    return () => import(/* webpackChunkName: "[request]" */ `@/views/${component}.vue`);
}

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/callback',
            name: 'callback',
            component: load('Callback')
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '*',
            redirect: '/Createbooking'
        },
        {
            path: '/displayLabel',
            name: 'displayLabel',
            component: load('displayLabel'),
            beforeEnter: authGuard,
            meta: {
                title: 'Label | Link Logistics'
            }
        },
        {
            path: '/logout',
            name: 'logout',
            component: Logout
        },
        {
            path: '/About',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: About,
            meta: {
                title: 'About | Link Logistics'
            }
        },
        {
            path: '/Createbooking',
            name: 'booking',
            component: load('createShipment'),
            beforeEnter: authGuard,
            meta: {
                title: 'Booking | Link Logistics'
            }
        },
        {
            path: '/UploadShipmentDocuments',
            name: 'upload',
            component: load('UploadShipmentDocuments'),
            beforeEnter: authGuard,
            meta: {
                title: 'Upload Document | Link Logistics'
            }
        },
        {
            path: '/History',
            name: 'history',
            component: load('History'),
            beforeEnter: authGuard,
            meta: {
                title: 'History | Link Logistics'
            }
        },
        {
            path: '/Invoice/:shipmentId&:linkId',
            name: 'invoice',
            component: load('CreateInvoice'),
            beforeEnter: authGuard,
            meta: {
                title: 'Invoice | Link Logistics'
            }
        },
        {
            path: '/Invoice',
            name: 'invoice',
            component: load('CreateInvoice'),
            beforeEnter: authGuard,
            meta: {
                title: 'Invoice | Link Logistics'
            }
        },
        {
            "path": "/ShotFile",
            "name": "shotFile",
            "component": load('ShotFile'),
            beforeEnter: authGuard,
            meta: {
                title: 'Shot File | Link Logistics'
            }
        },
        {
            "path": "/ShotFileShipments/:id",
            "name": "shotFileShipments",
            "component": load('ShotFileShipments'),
            beforeEnter: authGuard,
            meta: {
                title: 'Shot File Shipments | Link Logistics'
            }
        },
        {
            "path": "/Pickup",
            "name": "Pickup",
            "component": load('Pickup'),
            beforeEnter: authGuard,
            meta: {
                title: 'Pickup | Link Logistics'
            }
        },
        {
            "path": "/Scan",
            "name": "Scan",
            "component": load('Scan'),
            beforeEnter: authGuard,
            meta: {
                title: 'Scan App | Link Logistics'
            }
        },
        {
            path: '/test',
            component: load('test'),
        }
    ]
});

export default router;
